export const guion_view_component = (voices, currentVoice) => ({
    voices,
    selectedVoice: null,
    currentVoice,

    init(){
        if(currentVoice){
            this.selectedVoice = currentVoice.audio_id;
        } else if(voices.length > 0){
            this.selectedVoice = voices[0].id;
        }
    },


    async createGuionAudio(){
        const voice = voices.find(voice => voice.id === +this.selectedVoice);
        debugger
        const { isConfirmed } = await Swal.fire({
            title: 'Crear guion de audio',
            text: `Se creará un guion de audio con la voz ${voice.nombre}. ¿Continuar con la acción?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Crear',
            cancelButtonText: 'Cancelar'
        });

        if (!isConfirmed) return;

        try {
            $('#global-loader').loader('show');
            const url = `${window.location.pathname}/generar-guion-audio`;
            const { data } = await axios.post(url, {
                audio_id: this.selectedVoice,
                text: this.$refs.guion.innerHTML
            });

            this.$dispatch('add-toast', {
                type: 'success',
                title: 'Guion de audio creado',
                text: `Se ha creado un guion de audio con la voz <strong>${this.selectedVoice}</strong>`
            });

            console.log('data', data);

            this.currentVoice = data.audio;

            if (this.$refs.audio_player){
                this.$nextTick(() => this.$refs.audio_player.load())
            }

        } catch (error) {
            console.error('error', error);
            this.$dispatch('add-toast', {
                type: 'error',
                title: 'Fallo al crear guion de audio',
                text: 'Unespected error. See console for more details.'
            });
        } finally{
            $('#global-loader').loader('hide');
        }
    },

    // TODO: Crear un archivo de utilidad y colocar este código allí
    async downloadFile(url, fileName) {
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('No se pudo descargar el archivo');
            }

            const blob = await response.blob();

            // Crear una URL temporal para el blob
            const objectUrl = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = objectUrl;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();

            document.body.removeChild(a);
            window.URL.revokeObjectURL(objectUrl);
        } catch (error) {
            console.error(error);
            alert('Ocurrió un error al descargar el archivo');
        }
    },

    async downloadGallery(url){
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('No se pudo descargar el archivo');
            }

            const blob = await response.blob();

            // Crear una URL temporal para el blob
            const objectUrl = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = objectUrl;
            a.download = 'galeria.zip';
            document.body.appendChild(a);
            a.click();

            document.body.removeChild(a);
            window.URL.revokeObjectURL(objectUrl);

        } catch (error) {
            console.error(error);
            alert('Ocurrió un error al descargar la galeria');
        }
    }
});
